import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const generateId = () => Math.random().toString(36).substring(2) + Date.now().toString(36);

const AnalyticsTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Get or create visitor ID
    let visitorId = localStorage.getItem('voxit_visitor_id');
    if (!visitorId) {
      visitorId = generateId();
      localStorage.setItem('voxit_visitor_id', visitorId);
    }
    
    // Get or create session ID (expires after 30 min of inactivity)
    const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes
    let sessionId = sessionStorage.getItem('voxit_session_id');
    const lastActivity = sessionStorage.getItem('voxit_last_activity');
    
    if (!sessionId || !lastActivity || Date.now() - parseInt(lastActivity) > SESSION_TIMEOUT) {
      sessionId = generateId();
      sessionStorage.setItem('voxit_session_id', sessionId);
    }
    sessionStorage.setItem('voxit_last_activity', Date.now().toString());
    
    // Track page view
    const trackPageView = async () => {
      // Skip admin pages
      if (location.pathname.startsWith('/admin')) return;
      
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      
      try {
        await fetch(`${API_URL}/api/analytics/track`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            page_path: location.pathname,
            page_title: document.title,
            visitor_id: visitorId,
            session_id: sessionId,
            referrer: document.referrer,
            user_agent: navigator.userAgent
          })
        });
      } catch (error) {
        // Silently fail - don't break the user experience
        console.debug('Analytics tracking failed:', error);
      }
    };
    
    // Small delay to ensure page title is set
    const timer = setTimeout(trackPageView, 500);
    return () => clearTimeout(timer);
  }, [location.pathname]);
  
  return null;
};

export default AnalyticsTracker;
